module.exports = __webpack_public_path__ + "static/media/po_heng_chen.f8c95aa8.jpg";